module.exports = __webpack_public_path__ + "static/media/calendar.ce0a87e2.png";